// 📁 src/services/chatService.js
// ✅ VERSIÓN CON RUTAS CORREGIDAS PARA EVITAR 404

// La ruta base de la API. Si tu API no está en /api, ajusta esto.
const API_BASE_URL = '/api';
import { getSafeToken } from '../utils/tokenHelper';

/**
 * Crea un nuevo chat en el backend.
 */
export const createChat = async (payload) => {
  const token = getSafeToken();
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  const response = await fetch(`${API_BASE_URL}/chats/create`, { // Ruta corregida a /chats/
    method: 'POST',
    headers,
    body: JSON.stringify(payload)
  });
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || 'Error al crear un nuevo chat');
  }
  return await response.json();
};

/**
 * Obtiene todos los chats de un usuario.
 */
export const fetchUserChats = async (userEmail) => {
  const token = getSafeToken();
  const headers = {};
  if (token) headers['Authorization'] = `Bearer ${token}`;
  const response = await fetch(`${API_BASE_URL}/chats/user/${userEmail}`, { // Ruta corregida a /chats/
    headers
  });
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || 'Error al obtener los chats del usuario');
  }
  return await response.json();
};


/**
 * Obtiene un chat específico con todos sus mensajes por ID.
 */
export const fetchChatById = async (chatId) => {
  const token = getSafeToken();
  const headers = {};
  if (token) headers['Authorization'] = `Bearer ${token}`;
  const response = await fetch(`${API_BASE_URL}/chats/${chatId}`, { headers });
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || 'Error al obtener el chat por ID');
  }
  return await response.json();
};

/**
 * Elimina un chat específico por su ID.
 */
export const deleteChatById = async (chatId) => {
  const token = getSafeToken();
  const headers = {};
  if (token) headers['Authorization'] = `Bearer ${token}`;
  const response = await fetch(`${API_BASE_URL}/chats/${chatId}`, { // Ruta corregida a /chats/
    method: 'DELETE',
    headers
  });
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || 'Error al eliminar el chat');
  }
  return await response.json();
};

/**
 * Renombra un chat específico.
 */
export const renameChat = async (chatId, newName) => {
  const token = getSafeToken();
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  const response = await fetch(`${API_BASE_URL}/chats/${chatId}/rename`, { // Ruta corregida a /chats/
    method: 'PATCH',
    headers,
    body: JSON.stringify({ nuevoNombre: newName })
  });
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || 'Error al renombrar el chat');
  }
  return await response.json();
};

/**
 * Agrega un mensaje a un chat existente.
 */
export const addMessageToChat = async (chatId, messageData) => {
  const token = getSafeToken();
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  const response = await fetch(`${API_BASE_URL}/chats/${chatId}/message`, { // Ruta corregida a /chats/
    method: 'POST',
    headers,
    body: JSON.stringify(messageData)
  });
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || 'Error al agregar mensaje');
  }
  return await response.json();
};

/**
 * Avanza un paso en el modo simulador.
 */
export const avanzarPasoSimulador = async (payload) => {
  const token = getSafeToken();
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  const response = await fetch('/api/coach/simulador/paso', { // Esta ruta parece diferente, la dejamos como estaba en tu original
    method: 'POST',
    headers,
    body: JSON.stringify(payload)
  });
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || 'Error al avanzar paso del simulador');
  }
  return await response.json();
};



// ... (El resto de funciones se mantienen igual)
export const fetchChatResponse = async (usuario, asistente, messages, chatId, opcionSeleccionada) => { /* ... */ };
export const getFeedback = async (errorKey) => { /* ... */ };
export const iniciarModoCoach = async (modo, usuarioId) => { /* ... */ };
export const iniciarSimulador = async (chatId) => { /* ... */ };